export const questionnairesEndPoint = 'questionnaires/';
export const cancelRoute = 'cancel';
export const scheduleRoute = 'schedule';
export const approveRoute = 'approve';
